import axios from "axios";
import {errorMessage} from "../tools/messages";

axios.defaults.headers.post["Content-Type"] = "application/json";


axios.interceptors.response.use(null, error => {
    const executedErrors = error.response && error.response.status >= 400 && error.response.status < 500;
    if (executedErrors) {
        console.log(error, "HttpService")
        if (error.response.status === 401)
            errorMessage('نام کاربری یا رمز عبور اشتباه است')

        if (error.response.status === 400) {
            let res = error?.response?.data?.message
            errorMessage(JSON.parse(res)?.errors.join("\r\n"));
        }
    }

    return Promise.reject(error)
});

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    axios: axios
}




